<template>
    <fullscreen :index="998">
        <panel-call-details
            v-bind="{
                headerClass: 'call__header',
                data,
                specificData: {
                    allowFilling: false,
                    isOperateMenu: false
                },
                close: {
                    show: true,
                    action: closeView
                }
            }"
        >
            <template #panel__header>
                <base-audio
                    v-if="data.audioUrl"
                    :settings="{
                        id,
                        requestId: $route.params.id,
                        model: $route.meta.api
                    }"
                />
            </template>
        </panel-call-details>
    </fullscreen>
</template>

<script>
// package
import {
    onMounted,
    onBeforeUnmount,
    reactive,
    toRefs,
    watch
} from '@vue/composition-api';

// helpers
import { get } from '@/helpers/requests';

// store
import { mapState, useActions } from '@/hooks/use-store';

export default {
    components: {
        Fullscreen: () => import( /* webpackChunkName: 'Fullscreen' */ '@/components/bundles/layout/fullscreen/Fullscreen' ),
        PanelCallDetails: () => import( /* webpackChunkName: 'PanelCallDetails' */ '@/components/bundles/callDetails/childrens/PanelCallDetails' ),
        BaseAudio: () => import( /* webpackChunkName: 'BaseAudio' */ '@/components/bundles/players/audio/Audio' )
    },
    props: {
        id: Number,
        audioUrl: String
    },
    setup ( props, { emit, root: { $route } }) {
        const state = reactive({
            data: {}
        });
        // obtenção do payload
        const payload = mapState({ module: 'storePayload', key: 'payload' });
        // store
        const { actions } = useActions();
        // listener para validar quando deverá inserir o id da chamada
        // Só deverá aparecer quando o numero de campos for
        // igual a superior ou igual a 1.
        watch( () => payload.value,
            obj => {
                if ( Object.keys( obj ).length && !obj.requestId )
                    actions( 'registerField', { name: 'requestId', value: props.id });
            },
            { deep: true });
        onMounted( async () => {
            state.data = await get( `contacts/${$route.params.id}/calls/${props.id}` )
                .then( ({ data }) => data.content.data );
        });

        /**
         * [method]
         * Acção ao clickar na tecla `esc`.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const onEscape = event => {
            if ( event.which === 27 )
                closeView();
        };

        document.addEventListener( 'keydown', onEscape );

        onBeforeUnmount( () => {
            document.removeEventListener( 'keydown', onEscape );
        });

        /**
         * [method]
         * Click no botão.
         * Fecha a vista e volta a página.
         *
         * @since 1.0.0
         * @category Method
         * @autor Tiago Martinho
         *
        */
        const closeView = () => { emit( 'close' ); };

        return { ...toRefs( state ), closeView };
    }
};
</script>

<style lang="scss">
    .call {
        &__header {
            margin-bottom: 83px;
        }
    }
</style>